export default __webpack_public_path__ + "static/cht-ecb49de0ccae36fe3a48936ce1d2bb93.webp";